import PropTypes from 'prop-types';
import React from 'react';
import { isFragment } from 'react-is';
import styled from 'styled-components';
import Input from '../Input';

const LabledInput = ({ label, className, ...inputProps }) => (
  <StyledLabledInput className={className}>
    {typeof label === 'string' || isFragment(label) ? (
      <StyledLabel>{label}</StyledLabel>
    ) : (
      label
    )}
    <StyledInput {...inputProps} />
  </StyledLabledInput>
);

LabledInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
};

LabledInput.defaultProps = {
  className: '',
};

const StyledLabledInput = styled.div``;

const StyledInput = styled(Input)`
  width: 100%;
  font-size: inherit;
  box-sizing: border-box;
`;

const StyledLabel = styled.div`
  display: flex;
  margin-bottom: 6px;
  font-size: 9px;
  line-height: 11px;
  font-weight: normal;
  text-transform: uppercase;
  color: ${props => props.theme.colors.blackLight};
`;
LabledInput.Label = StyledLabel;

export default LabledInput;
